import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getProviderIPsInItems,
  getProviderInItems,
} from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import ProviderChartInItemsList from "components/ProviderDashboard/ProviderItems/ProviderChartInItemsList"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"
import ProviderIPsChartInItemsList from "components/ProviderDashboard/ProviderIPsItems/ProviderIPsChartInItems"

const ProviderIPsChartInItems = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
    type: searchParams.get("type"),
    ip_id: searchParams.get("ip_id"),
  }
  const type = searchParams.get("type")
  const ProviderInItems = useSelector(
    state => state.providerDashboard.ProviderInItems
  )

  useEffect(() => {
    dispatch(getProviderIPsInItems(getParams))

    return () => {
      dispatch(providerDashboardAction.resetProviderInItems())
    }
  }, [])

  return (
    <ProviderIPsChartInItemsList
      data={ProviderInItems?.data?.data}
      loading={ProviderInItems?.loading}
      type={type}
    />
  )
}

export default ProviderIPsChartInItems
